import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserTimezoneInfo } from '../../../../AngularJS/Admin/timezone.model';
import { GroupDTO } from '../../../reusables/assign-tool/angular-assign-tool/angular-assign-tool.models';
import { CVLocalizationService } from '../../../reusables/services/cv-localization.service';
import { TimezoneService } from '../../../reusables/services/timezone.service';
import { GroupTypeDTO, Language, LDGroupInfo, Permissions, ProfileDTO, RelatedGroupInfo, UpdateUserDTO, User, UserProfileDTO } from '../user-admin.model';
import { UserAdminService } from '../user-admin.service';

@Component({
    selector: 'cv-add-user',
    templateUrl: './add-user.component.html',
    styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
    public visible: boolean = false;
    @Input() set show(val: boolean) {
        this.visible = val;
        if (val == true) {
            this.resetUser();
            this.timezoneInfo = this.timezoneService.dataObj;
        }
    }
    @Output() public showChange = new EventEmitter<boolean>();
    @Output() public onSave: EventEmitter<any> = new EventEmitter<any>();
    @Input() public languages: Language[];
    @Input() public baseGroupTypes: string[] = [];
    @Input() public listProfileDTOs: ProfileDTO[] = [];
    @Input() public groupNames: GroupTypeDTO[] = [];
    @Input() public ldGroups: LDGroupInfo[] = [];

    public permissions: Permissions;
    public user: User = new User();
    public userProfile: UserProfileDTO = new UserProfileDTO();
    public userLang: string = "";
    public userImage: string = "";
    public groupLevelOptions: GroupTypeDTO[] = [];
    public ldGroupOptions: GroupDTO[] = [];
    public timezoneInfo: UserTimezoneInfo;
    private addingUser: boolean = false;
    public uploadingImg: boolean = false;
    public selecteduserpicturepath: string = "";

    constructor(
        private userAdminService: UserAdminService,
        private localizationService: CVLocalizationService,
        private timezoneService: TimezoneService
    ) {
        this.constructorAsync();
    }

    ngOnInit(): void {
    }

    async constructorAsync() {
        this.permissions = await this.userAdminService.getLoginUserPermissions();
    }

    saveDisabled(): boolean {
        return (
            this.user == null
            || this.user.Email == null
            || this.user.Email.trim() == ''
            || this.user.LoginName == null
            || this.user.LoginName.trim() == ''
            || this.user.ParentGroupID == null
            || this.user.ParentGroupID == -1
        );
    }

    onRelatedGroupTypeChange(event) {
        this.user.RelatedGroupType = this.user.RelatedGroupTypeName == "Employee" ? 0 : 1;

        //reset group level
        this.groupLevelOptions = [];
        this.user.RelatedGroupLevel = -1;
        this.user.RelatedGroupLevelName = "";
        this.groupNames.forEach(e => {
            if (e.BaseGroupType == this.user.RelatedGroupType)
                this.groupLevelOptions.push(e);
        });

        //reset ld group
        this.ldGroupOptions = [];
        this.user.RelatedGroupID = -1;
        this.user.RelatedGroupName = "";
        this.user.ParentGroupID = -1;
        this.user.ParentGroupName = "";
    }

    onRelatedGroupLevelChange(event) {
        let groupLevel: string = event.target.value;

        this.user.RelatedGroupLevel = this.groupLevelOptions.find(f => f.GroupTypeName == groupLevel).GroupLevel;

        //reset ld group
        this.ldGroupOptions = [];
        this.user.RelatedGroupID = -1;
        this.user.RelatedGroupName = "";
        this.user.ParentGroupID = -1;
        this.user.ParentGroupName = "";
        this.ldGroups.forEach(ldGroup => {
            if (ldGroup.Key == this.user.RelatedGroupLevelName && ldGroup.Value.length > 0 && ldGroup.Value[0].BaseGroupType == this.user.RelatedGroupType) {
                ldGroup.Value.forEach(group => {
                    this.ldGroupOptions.push(group);
                });
            }
        });
    }

    onLDGroupChange(event) {
        let group: GroupDTO = this.ldGroupOptions.find(f => f.GroupName == this.user.RelatedGroupName);
        this.user.RelatedGroupID = group.GroupID;
        this.user.ParentGroupID = group.ParentGroupID;
        this.user.ParentGroupName = "N/A";
        this.ldGroups.forEach((LDGroup) => {
            if (LDGroup.Value[0] != null)
                if (LDGroup.Value[0].GroupLevel == this.user.RelatedGroupLevel + 1)
                    if (LDGroup.Value[0].BaseGroupType == this.user.RelatedGroupType) {
                        for (let i = 0; i < LDGroup.Value.length; ++i) {
                            if (LDGroup.Value[i].GroupID == this.user.ParentGroupID) {
                                this.user.ParentGroupName = LDGroup.Value[i].GroupName;
                                break;
                            }
                        }
                        return;
                    }
        });
    }

    updateUserImage(img: string) {
        if (!img || img.trim() == "")
            return;
        this.userImage = img;
        $("#profilePic_new").css("background-image", "url(" + img + ")");
        this.uploadingImg = false;
    }

    async saveUser() {
        if (this.addingUser || this.saveDisabled() || !this.permissions.CreateAccess)
            return;
        this.addingUser = true;

        this.user.LocalizationSetting = this.languages?.find(f => f.Value == this.userLang)?.Key ?? 0;
        this.user.ProfileID = this.listProfileDTOs.find(f => f.ProfileName == this.user.ProfileName).ProfileID;

        let newUser: UpdateUserDTO = new UpdateUserDTO();

        Object.assign(newUser, this.userProfile, this.user);
        let loginID: number = -1;
        try {
            loginID = await this.userAdminService.commitNewUser(newUser);
        }
        catch (err) {
            console.error("Could not save the new user: ", err);
            let errorMessage: string = "An error has occurred.";
            if (err && err.status_code == 400 && err.warnings.length && err.warnings[0])
                errorMessage = htmlEncode(err.warnings[0]);

            showErrorMessage(errorMessage, "Error");
        }
        if (loginID > 0) {
            if (!!this.userImage && this.userImage.trim() != "") {
                this.userAdminService.updateUserImage(loginID, this.userImage);
            }

            this.onSave.emit();
            this.closeModal();
        }
        this.addingUser = false;
    }

    closeModal() {
        this.resetUser();
        this.show = false;
        this.showChange.emit(this.show);
    }

    resetUser() {
        let profile: ProfileDTO = null;
        if (this.listProfileDTOs.length > 0)
            profile = this.listProfileDTOs[0];

        $("#profilePic_new").css("background-image", "url('../App_Themes/Standard/Images/CoreTheme/Profile/default_profile.svg')")
        this.user = new User();
        this.userProfile = new UserProfileDTO();

        this.userLang = "";
        this.user.TimeZoneInfoName = "Not Set";
        this.user.LocalizationSetting = -1;
        this.user.ProfileID = (profile == null) ? -1 : this.listProfileDTOs[0].ProfileID;
        this.user.ProfileName = (profile == null) ? "" : this.listProfileDTOs[0].ProfileName;
        this.user.RelatedGroupType = -1;
        this.user.RelatedGroupTypeName = "";
        this.user.RelatedGroupLevel = -1;
        this.user.RelatedGroupLevelName = "";
        this.user.RelatedGroupID = -1;
        this.user.RelatedGroupName = "";
        this.user.ParentGroupID = -1;
        this.user.ParentGroupName = "";
        this.user.ReceiveAlerts = true;
        this.user.ReceivePOAlerts = false;
        this.user.Active = true;
        this.user.MultiFactorRequired = false;
        this.groupLevelOptions = [];
    }
}
